@layer components {
  .chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 14px;
    border: 1px solid color-mix(in srgb, var(--white) 40%, transparent);
    border-radius: 999px;
    font-size: 16px;
    white-space: nowrap;
    transition-property: background-color, border-color, color;
    transition-duration: var(--duration);
    transition-timing-function: var(--easing);

    &:hover, &:focus-visible {
      background-color: var(--blue);
      border-color: var(--blue);
    }

    &[aria-pressed="true"] {
      background-color: var(--white);
      border-color: var(--white);
      color: var(--navy);
    }
  }

  .count {
    opacity: 0.6;
  }
}
